import { AbstractApiService } from '../abstractions/AbstractApiService';
import { OnRequestSuccess, OnRequestError, OnRequest, OnError } from './Responses';
import { IRegisterModel } from '../models/IRegisterModel';
import { ILoginModel } from '../models/ILoginModel';
import { IHistoryEntry } from '../models/IHistoryEntry';
import { IResetPassword } from '../models/IResetPassword';
import { IPinModel } from '../models/IPinModel';
import { IUserInfo } from 'src/models/IUserInfo';
import { IRegisterResult } from 'src/models/IRegisterResult';
import { IRetryEmailValidation } from 'src/models/IRetryEmailValidation';
import { IChangePasswordModel } from 'src/models/IChangePasswordModel';

export class IdentityService extends AbstractApiService {
    constructor() {
        super();
    }

    public LogIn(loginData: ILoginModel, onSuccess: OnRequest<IUserInfo>, onError: OnError<string>): void {
        this.PostTemplate('api/account/login', loginData, onSuccess, onError);
    }

    public GetProfileInfo(onSuccess: OnRequest<IUserInfo>, onError: OnError<string>): void {
        this.GetTemplate('api/account/info', onSuccess, onError);
    }

    public LogOut(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/account/logout', {}, onSuccess, onError);
    }

    public Register(data: IRegisterModel, onSuccess: OnRequest<IRegisterResult>, onError: OnError<IRegisterResult>): void {
        this.PostTemplate('api/account/register', data, onSuccess, onError);
    }

    public RegenerateConfirm(professionalNumber: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/account/regenerateconfirm?pwzfOrEmail=' + professionalNumber, onSuccess, onError);
    }

    public ResetPasswordRequest(userEmail: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/account/resetpasswordrequest', userEmail, onSuccess, onError);
    }

    public ChangePassword(model: IChangePasswordModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/account/changepassword', model, onSuccess, onError);
    }

    public ResetPassword(model: IResetPassword, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/account/resetpassword', model, onSuccess, onError);
    }

    public SetPin(model: IPinModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/account/setpin', model, onSuccess, onError);
    }

    public ConfirmEmail(userId: string, confirmationToken: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/account/emailconfirm?userId=' + userId +
            '&confirmationToken=' + confirmationToken,
            onSuccess, onError);
    }

    public ResendEmailVerification(model: IRetryEmailValidation, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/account/retryemailvalidation', model, onSuccess, onError);
    }

    public GetLoginHistory(quantity: number, onSuccess: OnRequest<IHistoryEntry[]>, onError: OnRequestError): void {
        this.Get('api/account/entryhistory?count=' + quantity, onSuccess, onError);
    }

    public GetSettingsInfo(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/account/settings', onSuccess, onError);
    }

    public RemovePin(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/account/removepin', onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/IdentityService.tsx